import { HttpErrorResponse } from "@angular/common/http";
import {
  Component,
  EventEmitter,
  Inject,
  Input,
  OnInit,
  Output,
  ViewChild,
} from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import {
  DataStateChangeEventArgs,
  GridComponent,
  PageSettingsModel,
} from "@syncfusion/ej2-angular-grids";
import { ToastrService } from "ngx-toastr";
import { Observable, Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { CommonHttpService } from "src/app/common.service";
import { GlobalComponent } from "src/app/global/global.component";
import { GeneralService } from "src/app/service/general.service";
import { CompanyList, functionpermission, GetCompanyBase, IsViewEdit } from "../../agency.model";
import { AgencyService } from "../../agency.service";
import { GetHTTPServiceCompany } from "../../company-list-data.service";


@Component({
  selector: "app-company-list",
  templateUrl: "./company-list.component.html",
  styleUrls: ["./company-list.component.scss"],
})

export class CompanyListComponent implements OnInit {  
  @Input() listInput: IsViewEdit;  
  @Output() listOutputEmit = new EventEmitter<IsViewEdit>();
  @ViewChild("grid") public grid: GridComponent;
  ////////////////////////////////functionality initialization////////////////////
  isEditCompany: boolean = false;
  isView: boolean = false;
  Type: string = "edit";
  isEdit: boolean = false;
  modalType: string;

  stateList: any = [];
  statusList: any = [];
  CompanyStatusList: any = [];

  public companyData: Observable<DataStateChangeEventArgs>;
  public newState: DataStateChangeEventArgs;

  ListCompanyBO: GetCompanyBase = new GetCompanyBase();
  private onDestroy$: Subject<void> = new Subject<void>();
  fp: functionpermission = new functionpermission();
  Company: CompanyList = new CompanyList();

  public filterSettings: object;
  initialPage: PageSettingsModel;
  public pageSizes: number[] = [10, 15, 20, 50, 100, 250];

  companyFormGroup: FormGroup;

  constructor( @Inject(GetHTTPServiceCompany) public getHttp: GetHTTPServiceCompany,
    public global: GlobalComponent,
    public toastrService: ToastrService,
    public httpService: AgencyService,
    public commonhttp: CommonHttpService,
    public general: GeneralService,
    private fb: FormBuilder,
    
 ) {

    this.companyData = getHttp;
    this.companyFormGroup = this.fb.group({
      Companyname: ["", Validators.required],
      fullName: ["", Validators.required],
      street: [""],
      city: [""],
      state: [""],
      zipcode: [""],
      phone: [""],
      fax: [""],
      fein: ["",Validators.required],
      Status: ["", Validators.required],
    });
  }

  get Companyname() {
    return this.companyFormGroup.get("Companyname");
  }

  get fullName() {
    return this.companyFormGroup.get("fullName");
  }

  get Status() {
    return this.companyFormGroup.get("Status");
  }

  get fein() {
    return this.companyFormGroup.get("fein");
  }

  ngOnInit(): void {
    this.getStatusDropDown();
    this.getStatesField();

    this.filterSettings = {
      type: "Menu",
    };
    this.initialPage = {
      currentPage: 1,
      totalRecordsCount: 0,
      pageCount: 10,
      pageSize: this.pageSizes[0],
      pageSizes: this.pageSizes,
    };
    this.getpermission()
  }

  getpermission() {
    if (this.global.LoginUserType.toUpperCase() != 'ONBOARD' && (this.global.globalAgencyId!=null&&this.global.globalAgencyId!=undefined&&this.global.globalAgencyId!='')) {
    let params = new URLSearchParams();
    params.append("pagecode", "Agency");
    params.append("roleId", this.global.roleId);
    params.append("agencyId", this.global.globalAgencyId)
    this.httpService.getpermission(params).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      if (data != null) {
        this.fp = data;
      }
      else {
        this.fp = new functionpermission();
      }
    },
      (err: HttpErrorResponse) => {
        this.fp = new functionpermission();
      })
  }
}

  //---------------------------------------------------------- Phone Format ---------------------------------------------------------------------------------------------///
  DemographicPhoneFormat() {
    this.Company.phoneNumber = this.general.converPhoneGoogleLib(
      this.Company.phoneNumber
    );
    this.Company.fax = this.general.converPhoneGoogleLib(this.Company.fax);
  }

  //-------------------------------------------------------------key press----------------------------------------------------------------------------------//
  keyPress(event: any) {
    const pattern = /[0-9]/;
    let inputChar = String.fromCharCode(event.charCode);
    if (event.keyCode != 8 && !pattern.test(inputChar)) {
      event.preventDefault();
    }
  }

  getCompanyList() {
    this.getHttp.execute(this.ListCompanyBO);
    let count = 0;
    this.companyData.pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      count += 1;
    });
    console.log("companyData",this.companyData);
  }

  reset() {
    this.companyFormGroup.reset();
  }

  show() {
    this.grid.columnChooserModule.openColumnChooser(500, 50);
  }

  getStatusDropDown() {
    let params = new URLSearchParams();
    params.append("ListCode", "STATUS");
    this.httpService
      .getLovStatus(params)
      .pipe(takeUntil(this.onDestroy$))
      .subscribe((data: any) => {
        this.statusList = JSON.parse(JSON.stringify(data));

        this.statusList.forEach((ele) => {
          ele.Key = ele.id;
          ele.Value = ele.lovName;
          delete ele.id;
          delete ele.lovCode;
          delete ele.lovName;
          delete ele.lovValue;
        });
        this.CompanyStatusList = data;
        let values = {
          id: null,

          lovName: "All",

          lovCode: "ALL",

          lovValue: "ALL",
        };
        this.CompanyStatusList.push(values);
        
        this.ListCompanyBO.statusLid = this.CompanyStatusList.filter(
          (e) => e.lovName == "Active"
        )[0].id;
        this.getCompanyList();
      });
  }
  //------------------------ Grid Initialization -----------------------///////////
  refresh() {
    this.getStatusDropDown();
   // this.getCompanyList();
  }
  // .........................................dataChangeMenus.....................................................//
  public dataChangeCompany(com): void {
    let val = com.action.requestType.toString();
    if (val != "filterchoicerequest") {
      if ((com.sorted || []).length) {
        this.ListCompanyBO.orderColumn = com.sorted[0].name;
        this.ListCompanyBO.orderType =
          com.sorted[0].direction === "descending" ? "DESC" : "ASC";
      }
    }
    if (val == "filtering" && com.action.action != "clearFilter") {
      this.ListCompanyBO.value = com.action.currentFilterObject.value;
      this.ListCompanyBO.field = com.action.currentFilterObject.field;
      this.ListCompanyBO.matchCase = com.action.currentFilterObject.matchCase;
      this.ListCompanyBO.operator = com.action.currentFilterObject.operator;
    } else {
      if (val == "filtering" && com.action.action == "clearFilter") {
        this.ListCompanyBO.field = "name";
        this.ListCompanyBO.matchCase = false;
        this.ListCompanyBO.operator = "contains";
        this.ListCompanyBO.value = "";
        this.ListCompanyBO.type = "string";
      }
    }
    this.getCompanyList();

    if (val == "paging" && com.action.name == "actionBegin") {
    }
  }

  /// .........................................onActionMenus.....................................................//
  public onActionCompany(com) {
    this.ListCompanyBO.currentpageno =
      this.grid.pagerModule.pagerObj.currentPage;
    this.ListCompanyBO.pageitem = this.grid.pagerModule.pagerObj.pageSize;
    if (com.name == "actionBegin" && com.requestType == "filterbeforeopen") {
      this.ListCompanyBO.type = com.columnType;
    }
  }

  closeNofun() {
    document.getElementById("cancelmodalspan").click();
  }
  getStatesField() {
    this.commonhttp
      .getJSON()
      .pipe(takeUntil(this.onDestroy$))
      .subscribe((data) => {
        this.stateList = data;
      });
  }

  CreateorUpdateList(data) {
    this.modalType = data;
    if (this.modalType == "new") {
      this.Company = new CompanyList();
      this.Company.statusLid = this.CompanyStatusList.filter(
        (e) => e.lovName == "Active"
      )[0].id;
    } else {
      this.modalType = "edit";
    }
  }

  getCompanyDetails(data) {
    this.Company = JSON.parse(JSON.stringify(data));   
    this.Company.fEIN = data.fein;
  }

  dataEmitAgency() { 
    this.listInput.isView = false;  
    this.listOutputEmit.emit(this.listInput);
  }

  saveCompany() {
    var saveList: CompanyList = JSON.parse(JSON.stringify(this.Company));
    if (this.modalType == "new") {
      saveList.id = "00000000-0000-0000-0000-000000000000";
    } else {
      saveList.id = this.Company.id;
    }
    saveList.id = this.Company.id;
    saveList.statusLid = this.Company.statusLid;
    if (saveList.phoneNumber != null && saveList.phoneNumber !=  undefined ) {
      saveList.phoneNumber = this.general.reconverPhoneGoogleLib(saveList.phoneNumber);
    }
    if (saveList.fax != null && saveList.fax != undefined) {
      saveList.fax = this.general.reconverPhoneGoogleLib(saveList.fax);
    }
    this.httpService
      .saveupdateCompany(saveList)
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(
        (data: any) => {
          if (data) {
            if (saveList.id == "00000000-0000-0000-0000-000000000000") {
              this.toastrService.success(
                "Company created successfully",
                "Company created!"
              );
              this.reset();
          
              setTimeout(() => {
                this.toastrService.clear();
              }, 6000);
            } else if (this.modalType == "edit") {
              this.toastrService.success(
                "Company Updated successfully",
                "Company updated!"
              );
            
              setTimeout(() => {
                this.toastrService.clear();
              }, 6000);
            }
            this.getCompanyList();
            document.getElementById('EditCompany').click();
          }
        },
        (err: any) => {
          if (err) {
            this.toastrService.error(err, "error");
            setTimeout(() => {
              this.toastrService.clear();
            }, 8000);
          }
        }
      );
  }
}
